import BaseApi from '../../../api/BaseApi';

const basePath = '/admin/product';
class AdminProductApi {
  static list(body) {
    return BaseApi.post(basePath + '/list', body);
  }
  static create(body) {
    return BaseApi.post(basePath + '/create', body);
  }
  static indexAll() {
    return BaseApi.post(basePath + '/indexAll', {});
  }
  static index(id) {
    return BaseApi.post(basePath + '/index/' + id, {});
  }
  static update(id) {
    return BaseApi.post(basePath + '/update/' + id, {});
  }
  static updateSubmit(id, body) {
    return BaseApi.post(basePath + '/updateSubmit/' + id, body);
  }
  static view(id) {
    return BaseApi.post(basePath + '/view/' + id, {});
  }
  static delete(id) {
    return BaseApi.post(basePath + '/delete/' + id, {});
  }
  static listParents(body) {
    return BaseApi.post(basePath + '/listParents', body);
  }

  static updateRestrictionStatus() {
    return BaseApi.post(basePath);
  }
}

export default AdminProductApi;
